import React, { useEffect } from 'react'
import { useTypedSelector } from 'src/redux/index'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ContestModalTitle } from 'src/components/Global/Text/TitleText'
import { getLeaderBoardAction } from 'src/redux/actions/xcontest'
import { ContestModalWrapper } from '../About/style'
import {
  LeaderBoardItemWrapper,
  LeaderBoardItem,
  LeftContent,
  RightContent,
} from './style'
import { BsArrowUpCircle } from 'react-icons/bs'

const LeaderBoard = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const { id } = params
  console.log(id)

  useEffect(() => {
    dispatch(getLeaderBoardAction({ id }))
  }, [])

  const data = useTypedSelector((state) => state.xcontest.leaderboard)

  console.log(data)

  return (
    <ContestModalWrapper>
      <ContestModalTitle>Leaderboard</ContestModalTitle>
      <LeaderBoardItemWrapper>
        {data.map((item, index): any => {
          const { streak_emoji, initials, streak, name } = item
          return (
            <LeaderBoardItem key={index}>
              <LeftContent>
                {/* <p className="num">{index + 1}.</p> */}
                <p className="streak">{streak}.</p>
                <p className="initials">{initials}</p>

                <>
                  {name === 'You' ? (
                    <div className="name">
                      {name} <BsArrowUpCircle className="icon" />{' '}
                    </div>
                  ) : (
                    ''
                  )}
                </>
              </LeftContent>
              <RightContent>
                {/* <p className="streak">{streak}</p> */}
                <p className="emoji">{streak_emoji} </p>
              </RightContent>
            </LeaderBoardItem>
          )
        })}
      </LeaderBoardItemWrapper>
    </ContestModalWrapper>
  )
}

export default LeaderBoard
